import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services';

/**
 *  Guard to prevent navigation to routes that require not to be authenticated.
 *
 * @export
 */
@Injectable({ providedIn: 'root' })
export class NotAuthenticatedCanActivateGuard implements CanActivate {
    constructor(private authentication: AuthenticationService, private router: Router) {}

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            this.authentication.isAuthenticated().then(authenticated => {
                if (authenticated) {
                    this.router.navigate(['/']);
                    resolve(false);
                }
                resolve(true);
            });
        });
    }
}

/**
 *  Guard to prevent navigation to child routes that require not to be authenticated.
 *
 * @export
 */
@Injectable({ providedIn: 'root' })
export class NotAuthenticatedCanActivateChildGuard implements CanActivateChild {
    constructor(private authentication: AuthenticationService, private router: Router) {}

    async canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            this.authentication.isAuthenticated().then(authenticated => {
                if (authenticated) {
                    this.router.navigate(['/']);
                    resolve(false);
                }
                resolve(true);
            });
        });
    }
}
